import React from 'react';
import { useSubscription } from '../providers/SubscriptionProvider';
import { UpgradeModal } from '../../features/dashboard_user/components/billing/UpgradeModal';

export const GlobalUpgradeModal: React.FC = () => {
  const { isUpgradeModalOpen, hideUpgradeModal, refreshSubscription } = useSubscription();

  const handleUpgradeComplete = async () => {
    await refreshSubscription();
  };

  return (
    <UpgradeModal
      isOpen={isUpgradeModalOpen}
      onClose={hideUpgradeModal}
      onUpgradeComplete={handleUpgradeComplete}
    />
  );
};
